<template>
    <div>
        <div class="row">
			<div class="col-md-12 p-0 m-0">
                <el-card class="box-card col-md-12 mb-4">
                    <div slot="header" class="clearfix">
                        <strong><span>Store Report</span></strong>
                    </div>
                    <div style="margin:0px -20px;">
                        <el-tabs type="border-card" v-model="tabIndex" @tab-click="handleTabClick">
                            <el-tab-pane :label="item.label" :name="item.index" v-for="(item, index) in tabList" :key="index" >
                                <BrightReportContent :tabIndex="item.index" :tabName="item.name" :tabLabel="item.label"/>
                            </el-tab-pane>
                        </el-tabs>
                    </div>
                </el-card>
            </div>
        </div>
    </div>
</template>

<script>
import Basic from '@/components/page/Basic.js'
import BrightReportContent from '@/views/pages/BrightReport/BrightReportContent.vue'
//import {Rainbow, Config,Penanggalan, AxiosWithJar } from '@/utility.js'


export default
{
	extends:Basic,
	components: {
        BrightReportContent,
        //BarChart,
    },
    computed:{
        
	},
    watch:{
        
    },
    mounted(){
        this.$emit('childrenRoute')
    },
    data() {
		return {
            /*
            tab: {
                name: 'sales',
                label: 'Sales',
                index: 0,
            },
            */

            tabIndex: this.$route.query.tab ? this.$route.query.tab : '0', 
			tabList:[
				{label:'Sales', name: 'sales', index:'0'},
				{label:'SPD', name: 'spd', index:'1'},
				//{label:'Waste', name: 'waste', index:'2'},
                {label:'Store Performance', name: 'store', index:'3'},
                //{label:'Stock', name: 'stock', index:'4'},
                //{label:'Service Level', name: 'service', index:'5'},
                //{label:'Growth Outlet', name: 'outlet', index:'6'},
			],
        }
    },
    methods:{
        handleTabClick(tab, event) {
            let tabIndex = tab.$vnode.key
            let tabName = tab.name
            let tabLabel = tab.label

            this.tab.index = tabIndex
            this.tab.name = tabName
            this.tab.label = tabLabel
        },

    },
}

</script>


<style>
.el-tabs--border-card {
    background: #FFF;
    border: 1px solid #DCDFE6;
    box-shadow: 0 0px 0px 0 rgb(0 0 0 / 0%), 0 0 0px 0 rgb(0 0 0 / 0%) !important;
    /* box-shadow: 0 2px 4px 0 rgb(0 0 0 / 12%), 0 0 6px 0 rgb(0 0 0 / 4%); */
}

</style>